<div class="container-fluid row_banner pb-md-5">
  <app-header></app-header>
  <div class="container my-5">
    <div class="container py-5">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="payment-card">
            <!-- Payment Steps -->
            <div
              class="row mt-2"
              style="display: flex; justify-content: center"
            >
              <div class="col-md-6 col-sm-10 align-items-center">
                <div class="d-flex" style="justify-content: space-between">
                  <div>
                    <span
                      class="ms-2"
                      style="font-weight: 500; font-size: 16px; line-height: 22px"
                      >Payment</span
                    >
                  </div>
                  <div>
                    <span
                      class="ms-2"
                      style="
                        float: right;
                        font-weight: 500;
                        font-size: 16px;
                        line-height: 22px;
                      "
                      >Payment Completion</span
                    >
                  </div>
                </div>
                <div
                  class="d-flex"
                  style="
                    justify-content: space-between;
                    padding: 0px 70px 0px 40px;
                  "
                >
                  <div class="paybtn">1</div>
                  <div
                    class="flex-grow-1"
                    style="border-top: 1px solid #d1d1d1; margin-top: 12px"
                  ></div>
                  <div>
                    <span class="badge rounded-circle bg-light text-dark"
                      >2</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- Payment Plans -->
            <div class="row mt-3 plansdetail">
              <div class="col-lg-7">
                <div
                  class="form-group mb-3 payment-plan"
                  [id]="selectedplan === 'Monthly' ? 'selected-plan' : 'basic'"
                  (click)="
                    checkUserIdAndRoute(
                      'Monthly',
                      '$7.50',
                      'price_1Q6AFpIcvPV98dDokZi78LKx'
                    )
                  "
                >
                  <label class="custom-radio">
                    <input
                      type="radio"
                      name="plan"
                      [checked]="selectedplan === 'Monthly'"
                    />
                    <span class="checkmark"></span>
                    <span style="font-weight: 500; font-size: 18px"
                      >Monthly Plan -
                    </span>
                    <strong>$7.50/mo.</strong
                    ><del class="ms-2" style="font-size: 17px; font-weight: 500"
                      >$15</del
                    >
                  </label>
                  <p class="text-muted">
                    Perfect for individuals who need a basic plan.
                  </p>
                </div>
                <div
                  class="form-group mb-3 payment-plan"
                  [id]="
                    selectedplan === 'Quarterly'
                      ? 'selected-plan'
                      : 'professional'
                  "
                  (click)="
                    checkUserIdAndRoute(
                      'Quarterly',
                      '$15',
                      'price_1Q6AeuIcvPV98dDoc2fUYvhM'
                    )
                  "
                >
                  <label class="custom-radio">
                    <input
                      type="radio"
                      name="plan"
                      [checked]="selectedplan === 'Quarterly'"
                    />
                    <span class="checkmark"></span>
                    <span style="font-weight: 500; font-size: 18px"
                      >Quarterly Plan - </span
                    ><strong>$15/qu.</strong>
                    <del class="ms-2" style="font-size: 17px; font-weight: 500"
                      >$30</del
                    ></label
                  >
                  <p class="text-muted">
                    Suited for Quarterly needing more powerful tools.
                  </p>
                </div>
                <div
                  class="form-group mb-3 payment-plan"
                  [id]="selectedplan === 'annual' ? 'selected-plan' : 'annual'"
                  (click)="
                    checkUserIdAndRoute(
                      'annual',
                      '$40',
                      'price_1Q6Ag7IcvPV98dDoHGszhDz0'
                    )
                  "
                >
                  <label class="custom-radio">
                    <input
                      type="radio"
                      name="plan"
                      [checked]="selectedplan === 'annual'"
                    />
                    <span class="checkmark"></span>
                    <span style="font-weight: 500; font-size: 18px">
                      Annual Plan -</span
                    >
                    <strong>$40/annual.</strong
                    ><del class="ms-2" style="font-size: 17px; font-weight: 500"
                      >$80</del
                    >
                  </label>
                  <p class="text-muted">
                    Suited for Annual needing more powerful tools.
                  </p>
                </div>
              </div>
              <!-- Order Summary -->
              <div class="col-lg-5">
                <div
                  class="border rounded"
                  style="background: #f4f6f6; padding: 10px 10px 10px 10px"
                >
                  <h5 class="mb-3">Your order summary</h5>
                  <p class="mb-2"><strong>Grammarin Premium</strong></p>
                  <p class="mb-2">1 member</p>
                  <p class="mb-2">Billed {{ selectedplan }}</p>
                  <hr />
                  <div class="d-flex justify-content-between">
                    <div>
                      <p><strong>Due today:</strong></p>
                    </div>
                    <div>
                      <p style="font-weight: 500; font-size: 18px">{{ selectedplanamount }} USD</p>
                    </div>
                  </div>
                </div>
                <br />
                <!-- <div style=" margin-top: 15px;"> -->
                <div
                  id="recaptcha-container"
                  data-size="compact"
                  data-theme="light"
                ></div>

                <!-- </div> -->
                <button
                  class="btn w-100 continue-btn mt-2"
                  (click)="handleButtonClick()"
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- code for validation  -->
    <div
      *ngIf="error"
      class="backdrop"
      style="
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 1000;
      "
    ></div>

    <div
      *ngIf="error"
      class="content-div"
      style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 468px;
        height: 360px;
        background-color: white;
        z-index: 1010;
        border-radius: 4px;
        border: 1px solid white;
      "
    >
      <div class="text-center" style="margin-top: 9%">
        <img src="/assets/images/paraphrasing tool/alert.svg" />

        <div style="width: 440px; height: 64px; margin-left: 16px">
          <p
            class="error mt-4"
            style="font-size: 24px; font-weight: 500; line-height: 33.89px"
          >
            {{ errorAlerts }}
          </p>
        </div>

        <button
          class="mt-4 butn-alert"
          style="margin-top: 63px !important"
          (click)="closeErrorDiv()"
        >
          Ok
        </button>
      </div>
    </div>

    <div
      *ngIf="success"
      class="backdrop"
      style="
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 1000;
      "
    ></div>

    <div
      *ngIf="success"
      class="content-div"
      style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 468px;
        height: 360px;
        background-color: white;
        z-index: 1010;
        border-radius: 4px;
        border: 1px solid white;
      "
    >
      <div class="text-center" style="margin-top: 9%">
        <img
          src="/assets/images/paraphrasing tool/success.svg"
          style="width: 138px; height: 138px"
        />

        <p
          *ngIf="success"
          class="error mt-4"
          style="font-size: 24px; font-weight: 500; line-height: 33.89px"
        >
          {{ successAlert }}
        </p>
      </div>
    </div>
    <!-- code for validation  -->
  </div>
</div>
<app-footer></app-footer>
